'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _getSize = require('../../../helpers/getSize');

var _getSize2 = _interopRequireDefault(_getSize);

var _sizes = require('../../../constants/sizes');

var _colors = require('../../../constants/colors');

var _layout = require('../layout');

var _layout2 = _interopRequireDefault(_layout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DefaultIcon = function DefaultIcon(props) {
    return _react2.default.createElement(
        'svg',
        props,
        _react2.default.createElement(
            'defs',
            null,
            _react2.default.createElement('path', {
                id: 'a',
                d: 'M0 60h60V0H0z'
            })
        ),
        _react2.default.createElement(
            'g',
            {
                fill: 'none',
                fillRule: 'evenodd'
            },
            _react2.default.createElement(
                'mask',
                {
                    id: 'b',
                    fill: '#fff'
                },
                _react2.default.createElement('use', {
                    xlinkHref: '#a'
                })
            ),
            _react2.default.createElement('path', {
                fill: '#3F5060',
                mask: 'url(#b)',
                d: 'M22.5 54.375v4.687h1.875v-2.811h11.26l-.01 2.808 1.874.007.02-4.691z'
            }),
            _react2.default.createElement('path', {
                fill: '#3F5060',
                mask: 'url(#b)',
                d: 'M25.32 55.313h1.875V13.124H25.32zM32.82 55.313h1.875V13.124H32.82z'
            }),
            _react2.default.createElement('path', {
                fill: '#FFCF3F',
                mask: 'url(#b)',
                d: 'M29.07 41.25h1.875V13.125H29.07z'
            }),
            _react2.default.createElement('path', {
                fill: '#3F5060',
                mask: 'url(#b)',
                d: 'M23.438 10.313h13.14V8.437h-13.14zM23.438 14.063h13.14v-1.876h-13.14zM20.625 60H39.39v-1.875H20.625z'
            }),
            _react2.default.createElement('path', {
                fill: '#FFCF3F',
                mask: 'url(#b)',
                d: 'M16.875 60h1.875v-1.875h-1.875zM41.25 60h1.875v-1.875H41.25z'
            }),
            _react2.default.createElement('path', {
                fill: '#3F5060',
                mask: 'url(#b)',
                d: 'M25.313 13.125h1.875v-3.75h-1.875zM32.813 13.125h1.874v-3.75h-1.874z'
            }),
            _react2.default.createElement('path', {
                fill: '#FFCF3F',
                mask: 'url(#b)',
                d: 'M45 60h1.876v-1.875H45zM48.75 60h1.875v-1.875H48.75zM9.375 60h1.875v-1.875H9.375zM13.125 60H15v-1.875h-1.875z'
            }),
            _react2.default.createElement('path', {
                fill: '#FFEDBB',
                mask: 'url(#b)',
                d: 'M29.063 45h1.875v-1.875h-1.875zM29.063 48.75h1.875v-1.875h-1.875zM29.063 52.5h1.875v-1.875h-1.875z'
            }),
            _react2.default.createElement('path', {
                d: 'M1.875 35.907a12.103 12.103 0 0 0 9.375 4.405c3.654 0 7.053-1.6 9.375-4.405v-1.22H1.875v1.22zm9.375 6.28A13.97 13.97 0 0 1 .2 36.817l-.2-.255v-3.75h22.5v3.75l-.2.255a13.97 13.97 0 0 1-11.05 5.37z',
                fill: '#00D8C8',
                mask: 'url(#b)'
            }),
            _react2.default.createElement('path', {
                fill: '#3F5060',
                mask: 'url(#b)',
                d: 'M22.5 31.875h-1.875v-1.718L12.187 5.782V4.687h1.876v.78L22.5 29.844z'
            }),
            _react2.default.createElement('path', {
                fill: '#3F5060',
                mask: 'url(#b)',
                d: 'M1.875 31.875H0v-2.032L9.644 1.875h17.739V3.75H10.98L1.875 30.157z'
            }),
            _react2.default.createElement('path', {
                fill: '#3F5060',
                mask: 'url(#b)',
                d: 'M3.75 3.75h6.563V1.875H3.75z'
            }),
            _react2.default.createElement('path', {
                d: 'M39.375 35.907a12.103 12.103 0 0 0 9.375 4.405c3.654 0 7.053-1.6 9.375-4.405v-1.22h-18.75v1.22zm9.375 6.28a13.97 13.97 0 0 1-11.05-5.37l-.2-.255v-3.75H60v3.75l-.2.255a13.97 13.97 0 0 1-11.05 5.37z',
                fill: '#00D8C8',
                mask: 'url(#b)'
            }),
            _react2.default.createElement('path', {
                fill: '#3F5060',
                mask: 'url(#b)',
                d: 'M39.375 31.875H37.5v-2.032l8.438-24.375v-.78h1.874v1.095l-8.437 24.374z'
            }),
            _react2.default.createElement('path', {
                fill: '#3F5060',
                mask: 'url(#b)',
                d: 'M60 31.875h-1.875v-1.718L49.019 3.75H32.618V1.875h17.738L60 29.843z'
            }),
            _react2.default.createElement('path', {
                fill: '#3F5060',
                mask: 'url(#b)',
                d: 'M49.688 3.75h6.562V1.875h-6.563z'
            }),
            _react2.default.createElement('path', {
                d: 'M24.36 0l5.797 8.184L35.953 0H24.36zm3.624 1.875h4.344l-2.171 3.066-2.173-3.066z',
                fill: '#3F5060'
            })
        )
    );
};

DefaultIcon.defaultProps = {
    width: '60',
    height: '60',
    viewBox: '0 0 60 60',
    xmlns: 'http://www.w3.org/2000/svg',
    xmlnsXlink: 'http://www.w3.org/1999/xlink'
};

var ProfileIcon = function (_React$Component) {
    _inherits(ProfileIcon, _React$Component);

    function ProfileIcon() {
        _classCallCheck(this, ProfileIcon);

        return _possibleConstructorReturn(this, (ProfileIcon.__proto__ || Object.getPrototypeOf(ProfileIcon)).apply(this, arguments));
    }

    _createClass(ProfileIcon, [{
        key: 'render',
        value: function render() {
            var size = this.props.size || _sizes.Sizes.md;
            size = (0, _getSize2.default)(size);
            return _react2.default.createElement(
                _layout2.default,
                this.props,
                _react2.default.createElement(DefaultIcon, { fill: this.props.hover || this.props.active ? _colors.Colors.calmWhite : _colors.Colors.claimBlack, width: size + 'px', height: size + 'px' })
            );
        }
    }]);

    return ProfileIcon;
}(_react2.default.Component);

exports.default = ProfileIcon;